module.exports = __webpack_public_path__ + "static/img/eisbecher-rumtopf.d76c693.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/eisbecher-rumtopf.jpg
// module id = +rYq
// module chunks = 0